<template>
  <div>
    <br/>
    <h5 class="pageTitle">Activités saisonnières</h5>

    <h6><strong>Mode de réservaton :</strong></h6>
    <p>Les excursions sont contingentées à quinze participants. Les réservations doivent se faire auprès du responsable
      de l’excursion une semaine avant la tenue de l’activité par message courriel (ou par téléphone si c’est le seul
      renseignement indiqué). Si après l’envoi du message le membre ne reçoit pas de confirmation, c’est que le maximum
      de réservations aura été atteint et il ne recevra pas un retour de message pour l’en informer. On suggère aux
      participants qui ont réservé par courriel de consulter leurs courriels régulièrement avant la tenue de l’excursion
      au cas où il y aurait un problème.
    </p>
    <h6><strong>Avis important</strong></h6>
    <p>Il faut <strong>respecter en tout temps les règlements</strong> lorsque vous accéder, personnellement ou en groupe, aux <strong>endroits publics</strong>. Par exemple, s’il est mentionné « <strong>Interdiction de passer</strong> » ou « <strong>Sentier fermé</strong> », il ne faut pas y aller au risque d’avoir une contravention (amende à payer) comme, par exemple, à La Grande Ferme près de cap Tourmente.</p>

    <h6><strong>À consulter également:</strong></h6>
    <ul>
      <li @click="scrollMeTo('rules')"><span class="_link">Quelques règles de prudence lors des excursions</span></li>
      <li @click="scrollMeTo('policy')"><span class="_link">Politique du COQ pour l'accompagnement d'enfants lors d'excursions</span></li>
      <li @click="scrollMeTo('entente')"><span class="_link">Entente avec quatre instances de la SÉPAQ</span></li>
    </ul>

    <h6><strong>Utilisation du calendrier :</strong></h6>
    <p class="small">
      Cliquez sur une activité pour la voir en détail. Les flèches bleues servent à changer de mois.
    </p>

    <activities-list/>
    <br/>

    <h2 class="pageSubtitle">Quelques règles de prudence lors des excursions</h2>
    <a ref="rules"></a>
    <p>
      Ne rien laisser à la vue à l’intérieur de l’automobile lorsqu’elle est
      stationnée et d’objets de valeur dans le coffre de l’auto (caméra,
      jumelles, télescope) Si vous prévoyez laisser des objets de valeur dans le
      coffre, faites-le avant d’arriver à l’endroit où vous laisserez votre
      voiture. Les voleurs surveillent les stationnements pour ensuite aller
      voler ces objets durant votre absence.
    </p>

    <h2 class="pageSubtitle">Politique du COQ pour l'accompagnement d'enfants lors d'excursions</h2>
    <a ref="policy"></a>
    <ul>
      <li>
        À la page 8 du Guide d’animation pour les excursions ornithologiques,
        janvier 2007, du Regroupement QuébecOiseaux, on peut y lire : « De plus,
        il est suggéré d’aviser les gens que les enfants désireux de participer
        à une excursion doivent être accompagnés par un adulte; cela évite
        d’imposer à l’animateur(trice) une responsabilité supplémentaire. »;
      </li>
      <li>
        Le COQ adopte comme politique que la notion d’enfant dans ce contexte
        correspond à 12 ans et moins;
      </li>
      <li>
        Ces âges correspondent (à peu près) à la transition entre enfant et
        adolescent, ce dernier pouvant être gardien de plus jeunes.
      </li>
    </ul>

    <h2 class="pageSubtitle">Entente avec deux instances de la SÉPAQ</h2>
    <a ref="entente"></a>
    <p>
      Les directions du <strong>parc national de la Jacques-Cartier</strong> et du <strong>parc de la
      Chute-Montmorency</strong> sont fières de s’associer de nouveau au Club des ornithologues de Québec (COQ).
    </p>
    <p>
      Lors de leur arrivée à l’un ou l’autre parc, les membres devront présenter leur carte de membre ainsi qu’une pièce
      d’identité au poste de perception afin de bénéficier de la gratuité. Cette gratuité est applicable uniquement aux
      membres du Club. En contrepartie, ceux-ci devront :</p>
      <ul>
        <li>soit remplir un <a href="https://www.oiseauxqc.org/feuillet.pdf" target="_blank">feuillet d’observation
          quotidienne</a> et le remettre à un préposé à l’accueil avant de quitter le parc;
        </li>
        <li>soit soumettre les données directement sur eBird et faire parvenir le numéro de la liste d’observation, dans un délai de 5 jours :</li>
        <ul><li>pour le <strong>Parc national de la Jacques-Cartier</strong>, au responsable du service de la conservation par courriel à <a href="mailto:jacques.mariehelene@sepaq.com">jacques.mariehelene@sepaq.com</a>.</li><li>pour le <strong>Parc de la Chute-Montmorency</strong>, à la coordonnatrice au service à la clientèle et à l’animation à l' adresse <a href="mailto:boivin.marieelaine@sepaq.com">boivin.marieelaine@sepaq.com</a></li></ul>
        
      </ul>
    </p>
    <p>
      Notez que la liste d’observation doit être suffisamment étoffée en adéquation avec le privilège de l’entrée à
      titre gracieux sur le site.
    </p>
    <p>
      La remise de la liste des oiseaux observés est essentielle car les informations qu’elle contient contribuent à
      améliorer la connaissance sur les oiseaux qui fréquentent les parcs qui participent à l’entente.
    </p>

  </div>
</template>

<script>
  import ActivitiesList from '../components/Activites/Activites_Liste';

  export default {
    name: 'Activites',
    components: { ActivitiesList },
    methods: {
      scrollMeTo(refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;

        window.scrollTo(0, top);
      }
    }
  };
</script>

<style scoped>
p {
  margin-left: 0 !important;
}

a {
  font-size: 12px !important;
  text-decoration: underline;
}
</style>
